import { EmailHelper, PaymentProcessorOnboardingStatusTypes } from "../../enums/invoice/invoice.enum";

export interface SettingsDTO {
  Name: string;
  Value: string;
  Type: number;
  DefinitionFlag: number;
  AccountSettingStatusType: number;
  ProjulSettingStatusType: number;
}

export interface IIndexable {
  [key: string]: any;
}

export var settingsProp = {
  PaymentsEnabledForPastInvoices: false,
  ViewJustiFiIntegrationForDemo: false,
  JustiFiOnboardingSettings:
  {
    Status: PaymentProcessorOnboardingStatusTypes.OnboardingNotStarted,
    Country: 'US',
    Account: {
      id: '',
      name: '',
      account_type: '',
      status: '',
      curreny: '',
      platform_account_id: '',
      processing_ready: false,
      payout_ready: false,
      created_at: '',
      updated_at: '',
    }
  },
  PaymentProcessingFee: {
    CC: {
      Value: 3.49 // percentage
    },
    ACH: {
      Value: 1, // percentage
      Min: 1.99, // amount in dollar
      Max: 30 // amount in dollar
    }
  },
  TermsofServiceAgreementCC: false, // credit card
  PaymentProcessorSettings:
  {
    ClientPaysCreditCardFees: false,
    ClientPaysACHFees: false,
    ClientPaysDebitCardFees: false,
    AllowOnlineCreditCardPayment: true,
    AllowOnlineACHPayment: false,
    AllowOnlineDebitCardPayment: true,
    IsJustiFiEnabled: true,
    PaymentOptions: {
      'Credit Card': true,
      ACH: true,
      'Debit Card': true
    }
  },
  estimateSettings: {
    EstimateLogo: '',
    EstimateAliasName: 'Estimate',
    LastDocumentNumber: '',
    EstimateNumberRules: {
      Prefix: '',
      Suffix: '',
      AffixDelimiter: '-',
      MinimumLength: 6,
      NumberContext: 'Estimates',
      IsDisabled: true,
    },
    ChangeOrderNumberRules: {
      Prefix: '',
      Suffix: '',
      AffixDelimiter: '-',
      InstanceDelimiter: '-',
      InstanceMinimumLength: 0,
      MinimumLength: 6,
      NumberContext: 'Estimates',
      IsDisabled: true,
    },
    ShowSignatureOnPrintedEstimateIsDisabled: false,
    DefaultTax: '',
    EstimateSalesTaxIsHidden: false,
    DisplaySubsectionPriceOnEstimate: true,
    RequireEstimateApprovalBeforeSendingIsEnabled: false,
    EstimateFieldsEditableIsEnabled: false,
    OpenEstimateEmailBehavior: 0,
    MarkEstimateAsSentWhenSendingEmail: false,
    CcCompanyEmail: [
      {
        Email: null,
        Name: '',
      },
    ],
    EstimateExpiresAfter: '',
    AllowApprovalAfterExpiration: false,
    CostLineDefaults: {
      Labor: {
        isTaxCompanyCost: false,
        isTaxable: false,
        minMarkupCost: '',
        defaultMarkupCost: '',
      },
      MaterialNonInventory: {
        isTaxCompanyCost: false,
        isTaxable: false,
        minMarkupCost: '',
        defaultMarkupCost: '',
      },
    },
    EstimateCustomProperties: [],
    EstimateCompanySettings: {
      website: '',
      licenseNumber: '',
      email: '',
      address: {
        street1: '',
        street2: '',
        street3: '',
        city: '',
        state: '',
        postalCode: '',
        latitude: '',
        longitude: '',
      },
      licenseNumberName: '',
      phoneNumber: '',
    },
    NonItemizedProductsAndServicesName: '',
    AccountingServiceEstimateSyncBehavior: '',
    EstimateDefaultPrintedPhotoSize: 1
  },
  InvoiceParentSettings: {
    EmailTemplateSendInvoiceHtml: EmailHelper.defaultInvoiceEmailTemplate,
    RequireInvoiceApprovalBeforeSendingIsEnabled: false,
    MarkInvoiceAsSentWhenSendingEmail: true,
    DisplayPaymentProgress: true,
    OpenInvoiceEmailBehavior: 'OpenWithTemplate',
    CcCompanyEmail: [
      {
        Name: '',
        Email: '',
      },
    ],
    MarkInvoiceRequireProjectToBeSent: false,
    // InvoiceTerm: InvoiceTermEnum.DueOnReceipt,

    InvoiceSettings: {
      InvoiceNumberRules: {
        InstanceDelimiter: '-',
        InstanceMinimumLength: 0,
        NumberContext: '',
        Prefix: 'INV',
        Suffix: '',
        AffixDelimiter: '-',
        MinimumLength: 4,
        IsDisabled: true,
      },
      AutoGenerateInvoiceNumberIsDisabled: false,

      Templates: [],
      CompanyLogoFileId: null,
      TermsDefault: 0,
      PaymentProcessorIntegrationIsEnabled: false,
      AccountingServiceInvoicePushIsDisabled: false,
      Terms: [{ name: "Due on receipt", code: 0, DueDaysFromInvoiceDate: 0 },
        { name: "Net 15", code: 1, DueDaysFromInvoiceDate: 15 },
        { name: "Net 30", code: 2, DueDaysFromInvoiceDate: 30 },
        { name: "Net 45", code: 3, DueDaysFromInvoiceDate: 45 },
        { name: "Net 60", code: 4, DueDaysFromInvoiceDate: 60 },
        {
          name: "Net 90", code: 5, DueDaysFromInvoiceDate: 90
        }],
      phoneNumber: '',
      licenseNumber: '',
      licenseNumberName: '',
      email: '',
      website: '',
      address: {
        street1: '',
        street2: '',
        street3: '',
        city: '',
        state: '',
        postalCode: '',
        latitude: '',
        longitude: '',
      },
      InvoiceDefaultPrintedPhotoSize: 1
    }
  },
}


